import type { User } from '@/modules/user/userTypes';
import type { RootState } from '@/rootReducer';
import { shallowEqual, useSelector } from 'react-redux';

export const useUserData = () => {
	const [user] = useSelector<RootState, [User]>(
		state => [state.user.getIn(['authorize', 'user']).toJS()],
		shallowEqual
	);

	return { user };
};
